import { useCallback } from 'react'

import { useQueryClient } from '@tanstack/react-query'
import { Button, HStack } from 'govwell-ui'
import { AIChatbotFAQFragment } from 'types/graphql'

import useDisclosure from 'src/hooks/use-disclosure'
import AnswerQuestionButton from 'src/pages/AIAssistantTrainPage/AnswerQuestionButton'
import DismissQuestionModal from 'src/pages/AIAssistantTrainPage/DismissQuestionModal'
import { QueryKey } from 'src/utils/queryClient'

type Props = {
  aiChatbotFAQ: AIChatbotFAQFragment
}

const UnansweredQuestionsTableButtons = (props: Props) => {
  const { aiChatbotFAQ } = props
  const queryClient = useQueryClient()

  const dismissModalState = useDisclosure()

  const refetch = useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey: [QueryKey.SearchAIChatbotFAQs] })
    await queryClient.invalidateQueries({ queryKey: [QueryKey.GetUnansweredAIChatbotFAQsCount] })
    await queryClient.invalidateQueries({ queryKey: [QueryKey.OrganizationAISettings] })
  }, [queryClient])

  return (
    <HStack gap={2} justify="end">
      <AnswerQuestionButton aiChatbotFAQ={aiChatbotFAQ} refetch={refetch} />
      <Button
        variant="default"
        icon="FaXmark"
        dataTestId="ai-train-dismiss-btn"
        onClick={dismissModalState.open}
      >
        Dismiss
      </Button>
      {dismissModalState.isOpen && (
        <DismissQuestionModal
          id={aiChatbotFAQ.id}
          onClose={dismissModalState.close}
          refetch={refetch}
        />
      )}
    </HStack>
  )
}

export default React.memo(UnansweredQuestionsTableButtons)
